import { Component } from '@angular/core';
import { membersuiteBatchEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'MemberSuite: Batches') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-membersuitebatch-form',
    templateUrl: './membersuitebatch.form.component.html'
})
export class membersuiteBatchFormComponent extends BaseFormComponent {
    public record!: membersuiteBatchEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

